<template lang="html">
  <div>
    <h4 class="title">
      <span class="font-weight-bold">{{ title }}</span>
    </h4>
    <v-list class="list-product">
      <template v-for="(item, idx) in products">
        <v-list-item :key="idx + '-product'" :disabled="checkDisabled(item)" :ripple="false" :class="[{ 'product_outstock': checkDisabled(item) }]" @click="showdata(item)">
          <v-list-item-avatar v-if="item.default_variant && item.default_variant.photos.length !== 0" class="list-img-square list-with-favorite">
            <img :src="item.photo_xs" @error="imageLoadError" @click.stop="viewImage(item.photo_md)">
            <v-btn v-if="item.is_favorite" color="white" dark x-small absolute bottom fab class="__btn-fav-list" @click.stop="removeFavorite(item.favorite_id, idx)">
              <v-icon color="red">
                mdi-heart
              </v-icon>
            </v-btn>
            <v-btn v-else color="white" dark x-small absolute bottom fab class="__btn-fav-list" @click.stop="createFavorite(item.id, idx)">
              <v-icon color="grey lighten-1">
                mdi-heart
              </v-icon>
            </v-btn>
          </v-list-item-avatar>
          <v-list-item-avatar v-else class="list-img-square list-with-favorite">
            <img :src="item.photo_xs" @error="imageLoadError" @click.stop="viewImage(item.photo_md)">
            <v-btn v-if="item.is_favorite" color="white" dark x-small absolute bottom fab class="__btn-fav-list" @click.stop="removeFavorite(item.favorite_id, idx)">
              <v-icon color="red">
                mdi-heart
              </v-icon>
            </v-btn>
            <v-btn v-else color="white" dark x-small absolute bottom fab class="__btn-fav-list" @click.stop="createFavorite(item.id, idx)">
              <v-icon color="grey lighten-1">
                mdi-heart
              </v-icon>
            </v-btn>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title class="mb-2" v-html="item.name" />
            <!-- <v-list-item-subtitle v-if="item.variants != ''">
              <template v-for="(child, key) in item.variants">
                {{ child.name }}
                <span v-if="(item.variants.length - key) != 1" :key="key + '-plus'" v-html="'/'" />
              </template>
            </v-list-item-subtitle> -->
            <v-list-item-subtitle>
              {{ item.description }}
            </v-list-item-subtitle>
          </v-list-item-content>
          <v-list-item-action class="text-right qty-notes">
            <div class="__productInCart d-flex">
              <transition name="fade">
                <div v-if="item.__cart_data.note" class="__noteProduct grey lighten-2 mr-2 px-1">
                  <v-icon color="white" size="14">
                    mdi-file-document-outline
                  </v-icon>
                </div>
              </transition>
              <transition :duration="{ enter: 2000 }" name="slide-fade">
                <div v-if="item.__cart_data.qty" class="__qtyProduct primary--text font-weight-bold">
                  {{ item.__cart_data.qty }}x
                </div>
              </transition>
            </div>
            <template v-if="checkStock(item) || item.is_out_stock || item.__cart_data.is_available === false">
              <v-list-item-subtitle class="font-weight-bold txt-not-available">
                {{ $t('not_available') }}
              </v-list-item-subtitle>
            </template>
            <template v-else>
              <template v-if="Number(item.pos_sell_price_dynamic) === 1 && Number($store.state.selected_outlet.setting.pos_dynamic_price_can_order) === 0">
                <v-list-item-subtitle class="font-weight-bold txt-price-dynamic">
                  {{ $t('order_at_cashier') }}
                </v-list-item-subtitle>
              </template>
              <template v-else>
                <template v-if="item.default_variant_id">
                  <v-list-item-subtitle class="font-weight-bold __col-price">
                    <span v-if="$store.state.selected_type === 'DINE-IN' || $store.state.selected_type === 'RESERVATION'" v-mask-money-only="defaultVariant(item, 'sell_price_pos')" />
                    <span v-else v-mask-money-only="defaultVariant(item, 'sell_price')" />
                    <span v-if="Number(defaultVariant(item, 'market_price')) !== 0" v-mask-money-only="defaultVariant(item, 'market_price')" class="market-price" />
                  </v-list-item-subtitle>
                </template>
                <v-list-item-subtitle v-else class="font-weight-bold __col-price">
                  <span v-if="$store.state.selected_type === 'DINE-IN' || $store.state.selected_type === 'RESERVATION'" v-mask-money-only="item.sell_price_pos" />
                  <span v-else v-mask-money-only="item.sell_price" />
                  <span v-if="Number(item.market_price) !== 0" v-mask-money-only="item.market_price" class="market-price" />
                </v-list-item-subtitle>
              </template>
            </template>
          </v-list-item-action>
        </v-list-item>
      </template>
    </v-list>
  </div>
</template>

<script>
import {
  setProductFavorite as setProductFav,
  delProductFavorite as delProductFav
} from '@/api/product'
export default {
  name: 'ListProduct',
  props: {
    products: {
      required: true,
      type: Array
    },
    title: {
      default: '',
      type: String
    },
    showdata: {
      required: true,
      type: Function
    },
    viewImage: {
      required: true,
      type: Function
    },
    listincart: {
      default: () => [],
      type: Array
    }
  },
  data() {
    return {
      formFavorite: {
        product_id: ''
      }
    }
  },
  methods: {
    imageLoadError(event) {
      event.target.src = require('@/assets/images/product_not_available.png')
    },
    async createFavorite(id, index) {
      this.formFavorite.product_id = id
      try {
        const { data } = await setProductFav(this.formFavorite)
        this.$store.state.loading_axios = false
        this.products[index].is_favorite = 1
        this.products[index].favorite_id = data.data.id
      } catch (e) {
        if (e.statusCode === 401) {
          const tmii_outlet = this.$store.state.store_tmii
          const url_id = this.$store.state.url_domain

          if (tmii_outlet.indexOf(url_id) !== -1) {
            this.$router.push({ name: 'login_guest', query: { redirect: this.$router.currentRoute.name }}).catch(() => {})
          } else {
            this.$router.push({ name: 'login', query: { redirect: this.$router.currentRoute.name }}).catch(() => {})
          }
        }
      }
    },
    async removeFavorite(id, index) {
      try {
        await delProductFav(id)
        this.$store.state.loading_axios = false
        this.products[index].is_favorite = 0
      } catch (e) {
        if (e.statusCode === 401) {
          const tmii_outlet = this.$store.state.store_tmii
          const url_id = this.$store.state.url_domain
          if (tmii_outlet.indexOf(url_id) !== -1) {
            this.$router.push({ name: 'login_guest', query: { redirect: this.$router.currentRoute.name }}).catch(() => {})
          } else {
            this.$router.push({ name: 'login', query: { redirect: this.$router.currentRoute.name }}).catch(() => {})
          }
        }
      }
    },
    defaultVariant(item, price) {
      const arrayData = item.variants
      const newObj = arrayData.filter(obj => {
        return obj.id === item.default_variant_id
      })
      if (newObj.length === 0) {
        return item[price]
      } else {
        return newObj[0][price]
      }
    },
    checkDisabled(item) {
      return this.checkStock(item) || Number(item.is_out_stock) === 1 || item.__cart_data.is_available === false
    },
    checkStock(item) {
      if (!item.has_variant) {
        if (item.track_inventory) {
          if (this.$store.state.selected_outlet.pos_disallow_sell_no_stock) {
            if (Number(item.hold_qty) > Number(item.stock_qty)) {
              return true
            } else {
              return false
            }
          } else {
            return false
          }
        } else {
          return false
        }
      } else {
        return false
      }
    }
  }
}
</script>
